import './dateElement.less'
import { formatDate, formatTime } from '../../utils/timeUtil'
import React from 'react'
import { Typography } from '@lightbeamai/design-system'

interface IProps {
  time: string | number
  className?: string
  hideTime?: boolean
}

const DateElement = (props: IProps): React.ReactElement => {
  const { time, className = '', hideTime = false } = props
  const handledDate = formatDate(time)
  const handledTime = formatTime(time)

  return (
    <Typography
      as="div"
      color="primary"
      variant="base"
      className={`time-container ${className}`}
      title={handledDate + ' ' + handledTime}
      data-test-id="date-element"
    >
      {handledDate}
      {hideTime ? '' : ` ${handledTime}`}
    </Typography>
  )
}

export default DateElement
